import { AbstractBiditComponent } from '../../../shared/controls/abstract.bidit.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AdminService } from '../../services/admin.service';
import { ImportItemQtyData, ImportItemQtyErrors } from '../models/import-item-qty.interface';
import { FileUpload } from '../../../shared/models/file.upload.interface';
import { FileService } from '../../../shared/services/file.service';
import { Component, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';


@Component({
  selector: 'app-import-item-qty',
  standalone: false,
  templateUrl: './import-item-qty.component.html',
  styleUrl: './import-item-qty.component.scss'
})
export class ImportItemQtyComponent extends AbstractBiditComponent implements OnInit {
  displayedColumns: string[] =
    ['itemDesc', 'rValue', 'itemTypeDesc', 'cost', 'mfrPart', 'itemQty', 'itemMessage'];  

  failedItems: ImportItemQtyData[] = [];
  fileSelected: boolean = false;
  fileBytes?: string;
  importFile?: any;
  importComplete: boolean = false;
  file: FileUpload;
  dataSource = this.failedItems;
   
  constructor(private dialog: MatDialog, protected adminService: AdminService,
    private fileService: FileService,
    public dialogRef: MatDialogRef<ImportItemQtyComponent>,
    private deviceDetectorService: DeviceDetectorService) {
    super(deviceDetectorService);
  }

  ngOnInit() {  
    this.isRequesting = false;
    this.errors = '';
  }

  importItemQty() {
    this.errors = '';

    if (this.fileBytes === undefined) {
      this.errors = 'File is required';
      return;
    }

    this.isRequesting = true;

    // Set File Information
    this.file = {
      fileName: this.importFile.name,
      fileSize: this.importFile.size,
      fileType: this.importFile.type,
      lastModifiedTime: this.importFile.lastModified,
      lastModifiedDate: this.importFile.lastModifiedDate,
    } as FileUpload;

    this.file.fileAsBase64 = this.fileBytes;

    if (this.fileBytes.length > 0) {
      this.fileSelected = true;
      this.errors = '';
    }

    /*  POST to server*/
    this.adminService.importItemQty(this.file)
      .subscribe({
        next: (resp) => {
          this.errors = "Upload complete";
          
          this.failedItems = resp;
          this.dataSource = this.failedItems;
          this.isRequesting = false;
          this.importComplete = true;
          if (this.failedItems.length === 0) {
            this.dialogRef.close(true);
          }
        },
        error: (error: string) => {
          this.isRequesting = false;
          alert($localize`Error - Unable to import file. Only .csv and .xlsx format files are supported.`);
        }
      });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  exportErrors() {
    let dealerId = this.adminService.getDealerId();
    this.isRequesting = true;

    let split = this.file.fileName.split('.');
    split.pop();
    let finalName = `${split[0]}-Errors.csv`;

    let errorRequest: ImportItemQtyErrors = { dealerId: dealerId, failedItems: this.failedItems }

    this.adminService.exportItemQtyErrorsList(errorRequest)
      .subscribe({
        next: (data) => {
          this.isRequesting = false;
          this.fileService.downloadFile(data, finalName);
          this.dialogRef.close(true);
        },
        error: (error: string) => this.onError(error)
      });
  }
    
}
